<script setup>
import { computed, inject, toRaw } from 'vue'
import { MenuItemList, buildTree, forEachInTree } from '@/Components/Navigation'

const props = defineProps({
  group: {
    type: String,
    required: false,
    default: 'desktop',
  },
})

const viewport = inject('viewport')

const value = defineModel()

const items = computed({
  get() {
    // Force Vue to track all viewport changes by accessing them
    const currentViewport = viewport.value
    const itemsData = value.value

    // Ensure Vue tracks changes to all viewport order properties
    Object.values(itemsData).forEach(item => {
      if (item.viewport) {
        // Access all viewport order properties to ensure reactivity
        item.viewport.mobile?.order
        item.viewport.tablet?.order
        item.viewport.desktop?.order
      }
    })

    return buildTree(itemsData, currentViewport)
  },
  set(updatedItems) {
    forEachInTree(updatedItems, (item, index, parent = null) => {
      const itemRef = value.value[item.id]
      itemRef.parent_id = parent ? parent.id : null

      // Sync order across all viewports for consistency
      // Use direct assignment to ensure Vue detects changes
      itemRef.viewport.mobile.order = index
      itemRef.viewport.tablet.order = index
      itemRef.viewport.desktop.order = index
    })
  },
})
</script>

<template>
  <div class="flex flex-col bg-gray-50">
    <div v-if="items.length === 0" class="p-3 text-sm text-gray-700 text-center">
      <p>{{ __('No items have been added.') }}</p>
    </div>
    <MenuItemList v-else :group="group" v-model="items" />
  </div>
</template>
